import * as $ from 'jquery';
import * as React from 'react';
import { doFetchLeaveTypesFromServer } from '../../Actions/Caches';
import Component from '../../Component';
import Back from '../../Components/Back';
import InputField from '../../Components/InputField';
import Line from '../../Components/Line';
import SelectField from '../../Components/SelectField';
import Submit from '../../Components/Submit';
import ToggleField from '../../Components/ToggleField';
import { STATUS } from '../../General';
import {
    leaveTypesOptionsFactory, notificationRuleEventClausesOptionsFactory, notificationRuleTypeSchedulerContentOptionsFactory,
    notificationRuleTypeSchedulerWhenOptionsFactory, notificationRuleTypesOptionsFactory, officesOptionsFactory, unitsOptionsFactory, usersOptionsFactory
} from '../../SelectOptionsFactories';

export default class Form extends Component {
    constructor(props: any) {
        super(props);
        this.state = {
            name: {
                touched: false,
                rules: this.Rules().BasicNameInputRules()
            },
            type: {
                touched: false,
//                rules: this.Rules().BasicSelectRules(),
                value: [1],
            },
            schedulerWhen: {
                touched: false,
                rules: this.Rules().BasicSelectRules()
            },
            schedulerContent: {
                touched: false,
                rules: this.Rules().BasicSelectRules()
            },
            leaveTypes: {
                touched: false,
                rules: this.Rules().BasicSelectRules()
            },
            events: {
                touched: false,
                rules: this.Rules().BasicSelectRules()
            },
            users: {
                touched: false,
                rules: this.Rules().BasicSelectRules()
            },
            filterBy: {
                touched: false,
                rules: this.Rules().BasicSelectRules()
            },
            forAllLeaveTypes: {
                touched: false,
                value: true
            },
            forCompany: {
                touched: false,
                value: true
            },
            add: {
                pleaseWait: false
            },
        };
    }

    render() {
        const t = this.translate();
        const caches: any = this.getCaches().getState();
        let ready = caches.users.status === STATUS.READY && caches.units.status === STATUS.READY && caches.offices.status === STATUS.READY;
        if (ready === false) {
            return this.renderLoading();
        }
        const leaveTypesOptions = leaveTypesOptionsFactory(caches.leaveTypes.arr, this.language());
        const usersOptions = usersOptionsFactory(caches.users.arr);
        const unitsOptions = unitsOptionsFactory(caches.units.arr);
        const officesOptions = officesOptionsFactory(caches.offices.arr);
        let usofunOptions: any = [];
        usersOptions.forEach((userOption: any) => {
            usofunOptions.push({ value: 'us-' + userOption.value, text: userOption.text });
        })
        unitsOptions.forEach((unitOption: any) => {
            usofunOptions.push({ value: 'un-' + unitOption.value, text: unitOption.text });
        });
        officesOptions.forEach((officeOption: any) => {
            usofunOptions.push({ value: 'of-' + officeOption.value, text: officeOption.text });
        });
        const notificationRuleEventClausesOptions = notificationRuleEventClausesOptionsFactory(t);
        const notificationRuleEventTypesOptions = notificationRuleTypesOptionsFactory(t);
        const notificationRuleTypeSchedulerWhenOptions = notificationRuleTypeSchedulerWhenOptionsFactory(t);
        const notificationRuleTypeSchedulerContentOptions = notificationRuleTypeSchedulerContentOptionsFactory(t);
        return <div className="container-fluid">
            <div className="row">
                <div className="col-12 mb-3">
                    <Back href={this.Urls().getNotificationRules()} />
                    <h5 className="mb-0 d-inline">{t('add.notification.rule')}</h5>
                </div>
            </div>
            <div className="row">
                <div className="col-12 mb-3">
                    <Line />
                </div>
            </div>
            <div className={this.getCardClassNameSize()}>
                <div className="card-body">
                    <form onSubmit={(event: any) => { this.submit(event); }}>
                        <fieldset>
                            <div className="row">
                                <div className="col-12 mb-3 mt-3">
                                    <InputField
                                        touched={this.state.name.touched}
                                        rules={this.state.name.rules}
                                        type="text"
                                        placeholder={t('name')}
                                        focus={this.isScreenSizeSmall() ? false : true}
                                        onChange={(value: any) => { this.setState({ name: Object.assign({}, this.state.name, { value: value }) }); }}
                                    />
                                </div>
                                <div className="col-12 mb-3 d-none">
                                    <SelectField
                                        defaultValue={this.state.type.value}
                                        touched={this.state.type.touched}
                                        options={notificationRuleEventTypesOptions}
                                        multiple={false}
                                        placeholder={t('type')}
                                        onChange={(value: any) => { this.setState({ type: Object.assign({}, this.state.type, { value: value }) }); }}
                                    />
                                </div>
                                {this.state?.type?.value && this.state?.type?.value[0] === 1 ?
                                    <>
                                        <div className="col-12 mb-3">
                                            <ToggleField
                                                defaultValue={this.state.forAllLeaveTypes.value}
                                                tooltip={t('for.all.leave.types')}
                                                onChange={(value: any) => { this.setState({ forAllLeaveTypes: Object.assign({}, this.state.forAllLeaveTypes, { value: value }) }); }}
                                            >
                                                {t('for.all.leave.types')}
                                            </ToggleField>
                                        </div>
                                        {!this.state.forAllLeaveTypes.value ?
                                            <div className="col-12 mb-3">
                                                <SelectField
                                                    defaultValue={this.state.leaveTypes.value}
                                                    touched={this.state.leaveTypes.touched}
                                                    options={leaveTypesOptions}
                                                    multiple={true}
                                                    placeholder={t('leave.types')}
                                                    maxDisplayedOptions={3}
                                                    onChange={(value: any) => { this.setState({ leaveTypes: Object.assign({}, this.state.leaveTypes, { value: value }) }); }}
                                                />
                                            </div>
                                            : null}
                                        <div className="col-12 mb-3">
                                            <SelectField
                                                defaultValue={this.state.events.value}
                                                touched={this.state.events.touched}
                                                options={notificationRuleEventClausesOptions}
                                                multiple={true}
                                                placeholder={t('when')}
                                                maxDisplayedOptions={3}
                                                onChange={(value: any) => { this.setState({ events: Object.assign({}, this.state.events, { value: value }) }); }}
                                            />
                                        </div>
                                    </> : null}
                                {this.state?.type?.value && this.state?.type?.value[0] === 2 ?
                                    <>
                                        <div className="col-12 mb-3">
                                            <SelectField
                                                defaultValue={this.state.schedulerWhen.value}
                                                touched={this.state.schedulerWhen.touched}
                                                options={notificationRuleTypeSchedulerWhenOptions}
                                                multiple={false}
                                                placeholder={t('when')}
                                                onChange={(value: any) => { this.setState({ schedulerWhen: Object.assign({}, this.state.schedulerWhen, { value: value }) }); }}
                                            />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <SelectField
                                                defaultValue={this.state.schedulerContent.value}
                                                touched={this.state.schedulerContent.touched}
                                                options={notificationRuleTypeSchedulerContentOptions}
                                                multiple={false}
                                                placeholder={t('content')}
                                                onChange={(value: any) => { this.setState({ schedulerContent: Object.assign({}, this.state.schedulerContent, { value: value }) }); }}
                                            />
                                        </div>
                                    </>
                                    : null}
                                <div
                                    className="col-12 mb-3 border border-top-0 border-right-0 border-left-0 rounded-0"
                                    style={{ borderColor: 'rgba(0, 0, 0, 0.125)!important' }}
                                />
                                <div className="col-12 mb-3">
                                    <ToggleField
                                        defaultValue={this.state.forCompany.value}
                                        tooltip={t('from.all.company.employees')}
                                        onChange={(value: any) => { this.setState({ forCompany: Object.assign({}, this.state.forCompany, { value: value }) }); }}
                                    >
                                        {t('from.all.company.employees')}
                                    </ToggleField>
                                </div>
                                {!this.state.forCompany.value ?
                                    <div className="col-12 mb-3">
                                        <SelectField
                                            defaultValue={this.state.filterBy.value}
                                            touched={this.state.filterBy.touched}
                                            options={usofunOptions}
                                            multiple={true}
                                            placeholder={t('from.whom')}
                                            maxDisplayedOptions={3}
                                            onChange={(value: any) => { this.setState({ filterBy: Object.assign({}, this.state.filterBy, { value: value }) }); }}
                                        />
                                    </div>
                                    : null}
                                <div
                                    className="col-12 mb-3 border border-top-0 border-right-0 border-left-0 rounded-0"
                                    style={{ borderColor: 'rgba(0, 0, 0, 0.125)!important' }}
                                />
                                <div className="col-12 mb-3">
                                    <SelectField
                                        defaultValue={this.state.users.value}
                                        touched={this.state.users.touched}
                                        options={usersOptions}
                                        multiple={true}
                                        placeholder={t('to.whom')}
                                        maxDisplayedOptions={3}
                                        onChange={(value: any) => { this.setState({ users: Object.assign({}, this.state.users, { value: value }) }); }}
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <Submit
                                        faIcon="far fa-hdd"
                                        disabled={!this.isFormValid()}
                                        blocked={this.state.add.pleaseWait}
                                    >
                                        {t('add.notification.rule')}
                                    </Submit>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    }

    isFormValid() {
        if (this.state?.type?.value && this.state?.type?.value[0] === 1) {
            return this.Validator().validate(this.state.name) && (!this.state.forAllLeaveTypes.value ? this.Validator().validate(this.state.leaveTypes) : true)
                && this.Validator().validate(this.state.type) && (!this.state.forCompany ? (this.state.filterBy.value ? this.Validator().validate(this.state.filterBy) : true) : true)
                && this.Validator().validate(this.state.users) && this.Validator().validate(this.state.events);
        }
        if (this.state?.type?.value && this.state?.type?.value[0] === 2) {
            return this.Validator().validate(this.state.name)
                && this.Validator().validate(this.state.type) && this.Validator().validate(this.state.schedulerContent)
                && this.Validator().validate(this.state.users) && this.Validator().validate(this.state.schedulerWhen);
        }
    }

    submit(event: any) {
        event.preventDefault();
        this.setState(
            {
                name: Object.assign({}, this.state.name, { touched: true }),
                type: Object.assign({}, this.state.type, { touched: true }),
                schedulerContent: Object.assign({}, this.state.schedulerContent, { touched: true }),
                schedulerWhen: Object.assign({}, this.state.schedulerWhen, { touched: true }),
                forAllLeaveTypes: Object.assign({}, this.state.forAllLeaveTypes, { touched: true }),
                forCompany: Object.assign({}, this.state.forCompany, { touched: true }),
                leaveTypes: Object.assign({}, this.state.leaveTypes, { touched: true }),
                users: Object.assign({}, this.state.users, { touched: true }),
                filterBy: Object.assign({}, this.state.filterBy, { touched: true }),
                events: Object.assign({}, this.state.events, { touched: true }),
            },
            () => {
                if (this.isFormValid()) { this.addNotificationRule(); }
            }
        );
    }

    addNotificationRule() {
        const t = this.translate();
        let notificationRuleFilterClauses: any = [];
        if (!this.state.forCompany.value) {
            if (this.state.filterBy.value)
                this.state.filterBy.value.forEach((filterBy: any) => {
                    if (filterBy.startsWith('us-')) {
                        notificationRuleFilterClauses.push({ companyUserId: filterBy.replaceAll('us-', '') })
                    }
                    if (filterBy.startsWith('un-')) {
                        notificationRuleFilterClauses.push({ companyUnitId: filterBy.replaceAll('un-', '') })
                    }
                    if (filterBy.startsWith('of-')) {
                        notificationRuleFilterClauses.push({ calendarId: filterBy.replaceAll('of-', '') })
                    }
                })
        }
        $.ajax({
            type: 'PUT',
            contentType: 'application/json',
            url: this.Endpoints().getNotificationRuleCreate(),
            dataType: 'json',
            cache: false,
            data: JSON.stringify({
                name: this.state.name.value,
                forAllLeaveTypes: this.state.forAllLeaveTypes.value,
                forCompany: this.state.forCompany.value,
                leaveTypes: !this.state.forAllLeaveTypes.value ? this.state.leaveTypes.value : null,
                users: this.state.users.value,
                events: this.state.events.value,
                when: this.state?.schedulerWhen?.value && this.state.schedulerWhen.value[0] ? this.state.schedulerWhen.value[0] : null,
                notificationRuleFilterClauses,
                content: this.state?.schedulerContent?.value && this.state.schedulerContent.value[0] ? this.state.schedulerContent.value[0] : null,
                type: this.state.type.value[0],
            }),
            beforeSend: () => {
                this.setState({ add: { pleaseWait: true } });
            },
            success: (data, textStatus, jqXHR) => {
                doFetchLeaveTypesFromServer(this.getCaches());
                this.successToastr(t('the.notification.rule.was.added'));
                this.goToNotificationRules();
            },
            error: (jqXHR, textStatus, errorThrown) => {
                if (+jqXHR.status === 400) {
                    var reason = jqXHR.getResponseHeader('REASON');
                    if (reason && reason === 'DUPLICATE') {
                        this.successToastr(t('notification.rule.duplicate'));
                        return;
                    }
                }
                this.generalErrorToastr();
            },
            complete: (jqXHR, textStatus) => {
                this.setState({ add: { pleaseWait: false } });
            }
        });
    }
}